<template>
  <div>
    <documentationView :question-list="questionList" redirect="fee-documentation" />
  </div>
</template>

<script>
import documentationView from '@/src/router/layouts/app-document/documentationView.vue'
import FEE_MANAGER_DATA from '@/src/router/layouts/app-document/fee-documentation/fee-manager.json'
export default {
  name: 'Questions',
  components: {
    documentationView,
  },
  data() {
    return {
      questionList: FEE_MANAGER_DATA[this.$route.params.id],
    }
  },
}
</script>
